import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import ChevronDownIcon from '@mui/icons-material/KeyboardArrowDown'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

import { theme } from '../../themes/theme'
import Button from '../common/Button'
import CreateDraftFromTemplateButton from './CreateDraftFromTemplateButton'

const StyledButton = styled(Button)`
  gap: 10px;
  .MuiSvgIcon-root {
    transform: scale(1.5);
    transform-origin: center;
  }
`

const Separator = styled.span`
  width: 1px;
  height: 15px;
  background: ${theme.colors.primaryButton.text};
  opacity: 0.6;
`

const StyledMenu = styled(Menu)`
  .MuiPaper-root {
    min-width: 200px;
    border-radius: 5px;
    background-color: ${theme.colors.background.medium};
    box-shadow: none;
  }

  .MuiList-root {
    padding: 5px 0;
  }
`

const StyledMenuItem = styled(MenuItem)`
  font-family: ${theme.fonts.body};
  font-size: 14px;
  padding: 0;

  &:hover {
    background-color: ${theme.colors.primaryLight};
  }
`

function CreateDraftFromTemplateListButton({ foiId, letterTemplates, handleCreateDraftFromTemplate = () => {} }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = event => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  const handleItemSuccess = letter => {
    handleClose()
    handleCreateDraftFromTemplate(letter)
  }

  if (letterTemplates.length === 0) {
    return null
  }

  return (
    <>
      <StyledButton onClick={handleClick} aria-haspopup="true" aria-expanded={open} type="button">
        Create from Template
        <Separator />
        <ChevronDownIcon />
      </StyledButton>
      <StyledMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}>
        {letterTemplates.map(template => (
          <StyledMenuItem key={template.id} component="div">
            <CreateDraftFromTemplateButton
              foiId={foiId}
              type="text"
              letterTemplateId={template.id}
              name={template.name}
              handleCreateDraftFromTemplate={handleItemSuccess}
            />
          </StyledMenuItem>
        ))}
      </StyledMenu>
    </>
  )
}

CreateDraftFromTemplateListButton.propTypes = {
  foiId: PropTypes.string.isRequired,
  letterTemplates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  handleCreateDraftFromTemplate: PropTypes.func
}

export default CreateDraftFromTemplateListButton
